// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TenantRole } from "./TenantRole";
import {
  TenantRoleFromJSON,
  TenantRoleFromJSONTyped,
  TenantRoleToJSON,
  TenantRoleToJSONTyped,
} from "./TenantRole";
import type { ProjectRole } from "./ProjectRole";
import {
  ProjectRoleFromJSON,
  ProjectRoleFromJSONTyped,
  ProjectRoleToJSON,
  ProjectRoleToJSONTyped,
} from "./ProjectRole";

/**
 *
 * @export
 * @interface InvitationCreate
 */
export interface InvitationCreate {
  /**
   *
   */
  email: string;
  /**
   *
   */
  tenantRole?: TenantRole;
  /**
   *
   */
  project?: string | null;
  /**
   *
   */
  projectRole?: ProjectRole | null;
}

/**
 * Check if a given object implements the InvitationCreate interface.
 */
export function instanceOfInvitationCreate(value: object): value is InvitationCreate {
  if (!("email" in value) || value["email"] === undefined) return false;
  return true;
}

export function InvitationCreateFromJSON(json: any): InvitationCreate {
  return InvitationCreateFromJSONTyped(json, false);
}

export function InvitationCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): InvitationCreate {
  if (json == null) {
    return json;
  }
  return {
    email: json["email"],
    tenantRole: json["tenant_role"] == null ? undefined : TenantRoleFromJSON(json["tenant_role"]),
    project:
      json["project"] === undefined ? undefined : json["project"] === null ? null : json["project"],
    projectRole:
      json["project_role"] === undefined
        ? undefined
        : json["project_role"] === null
        ? null
        : ProjectRoleFromJSON(json["project_role"]),
  };
}

export function InvitationCreateToJSON(json: any): InvitationCreate {
  return InvitationCreateToJSONTyped(json, false);
}

export function InvitationCreateToJSONTyped(
  value?: InvitationCreate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    email: value["email"],
    tenant_role: TenantRoleToJSON(value["tenantRole"]),
    project: value["project"],
    project_role: ProjectRoleToJSON(value["projectRole"]),
  };
}
